import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';
import createLogger from './createLogger';
import { ERROR_CATEGORY, ERROR_LEVELS } from '../constants';
import { version } from '../../package.json';

const formatErrorMessage = ({
    message,
    componentName,
    correlationId,
    level,
// eslint-disable-next-line arrow-body-style
}) => {
    // ex: '[ui-floorplans]-v0.14.57-INFO-AppHeader-[correlationId: a-uuid]-Error doing something'
    return [
        `[${ERROR_CATEGORY}]`,
        `v${version}`,
        level,
        componentName,
        correlationId ? `[correlationId: ${correlationId}]` : '',
        message,
    ]
        .filter(Boolean)
        .join('-');
};

export default (WrappedComponent) => {
    const name = WrappedComponent.displayName || WrappedComponent.name;

    const info = (message, { correlationId, componentName = name } = {}) => {
        const infoString = formatErrorMessage({
            message,
            componentName,
            correlationId,
            level: ERROR_LEVELS.INFO,
        });
        // eslint-disable-next-line no-console
        console.info(infoString);
        // or we could log it to newrelic as an error
        // const logger = createLogger();
        // logger(infoString);
    };

    const error = (message, { correlationId, componentName = name } = {}) => {
        const logger = createLogger();
        const errorString = formatErrorMessage({
            message,
            componentName,
            correlationId,
            level: ERROR_LEVELS.ERROR,
        });
        logger(errorString);
    };

    const Component = (props) => (
        <WrappedComponent
            {...props}
            logger={{ error, info }}
        />
    );

    hoistNonReactStatics(Component, WrappedComponent);
    Component.propTypes = WrappedComponent.propTypes;

    Component.displayName = name || 'withLogger';

    return Component;
};
